import { forwardRef } from "react"
import AtomicTable from "./AtomicTable"
import AtomicURLTable from "./AtomicURLTable"

const WrappedAtomicTable = ({ isUsingURLState, ...props }, fwRef) => {
    if (isUsingURLState) {
        return <AtomicURLTable ref={fwRef} {...props} />
    }
    return <AtomicTable ref={fwRef} {...props} />
}

export default forwardRef(WrappedAtomicTable)
